module.exports = __webpack_public_path__ + "img/icon-validity-purple.c7d5cb28.svg";